import { NavTab, PageNav } from "@ugg/shared/components/common/PageNav";

interface TierlistNavsProps {
  tierlistType: string;
}

const TierlistNavs = (props: TierlistNavsProps) => {
  const rootPathName = `/deadlock/tier-list/`;
  const navLinks: NavTab[] = [
    { label: "Tier List", to: `${rootPathName}` },
    { label: "Duo Tier List", soon: true },
  ];
  return <PageNav tabs={navLinks} />;
};
export default TierlistNavs;
